/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import {UserVO} from '@/valueObjects/UserVO'
import {AnalysisService} from '@/services/AnalysisService'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import Download from '@/utils/Download'
import {Getter} from 'vuex-class'

@Component({
    mixins: [AnalysisServiceMixin],
})
export default class AnalysisDropdown extends Vue {
    @Getter('getCurrentUser') private currentUser: UserVO

    @Prop()
    private isFinished: boolean

    @Prop()
    private analysis: AnalysisVO
    private analysisService: AnalysisService


    public async downloadArtefacts(): Promise<void> {
        try {
            const data = await this.analysisService.getArtefacts(this.analysis.id)
            Download.makeDownloadLink(data, `analysis${this.analysis.id}.zip`)
        } catch (e) {
            this.$emit('exception', e.errorMessage)
        }
    }
    public async downloadStaticArtefacts(): Promise<void> {
        try {
            const data = await this.analysisService.getStaticArtefacts(this.analysis.id)
            Download.makeDownloadLink(data, `static_analysis${this.analysis.id}.zip`)
        } catch (e) {
            this.$emit('exception', e.errorMessage)
        }
    }
    public async downloadDynamicArtefacts(): Promise<void> {
        try {
            const data = await this.analysisService.getDynamicArtefacts(this.analysis.id)
            Download.makeDownloadLink(data, `dynamic_analysis${this.analysis.id}.zip`)
        } catch (e) {
            this.$emit('exception', e.errorMessage)
        }
    }
    public async downloadAPK(): Promise<void> {
        try {
            const data = await this.analysisService.getAPKArtefacts(this.analysis.id)
            Download.makeDownloadLink(data, `APK_analysis${this.analysis.id}.apk`)
        } catch (e) {
            this.$emit('exception', e.errorMessage)
        }
    }
    public async downloadLightReport(): Promise<void> {
        try {
            const data = await this.analysisService.getLightReport(this.analysis.id)
            Download.makeDownloadLink(data, `P2M_Analysis_Report_${this.analysis.id}_${this.analysis.hash}.pdf`)
        } catch (e) {
            this.$emit('exception', e.errorMessage)
        }
    }

    public yaraRescan() {
        this.$router.push(
            {
                name: 'yara-rescan',
                params: {analysisId: String(this.analysis.id)},
            })
    }

    private canEditAnalysis() {
        return this.analysis.userId === this.currentUser.id || this.currentUser.isAdmin()
    }
}
